import { forwardRef } from 'react';
import { clsx } from 'clsx';

import type { InputHTMLAttributes } from 'react';

import styles from './Input.module.css';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'style'> {
  /** The appearance of the element. Possible values: `error`. */
  appearance?: 'error';
  /** The type of the input element. */
  type?: 'text' | 'search' | 'password' | 'email' | 'file';
  /** `true` if the element should render at full width of its container; otherwise, `false`. The default is `false`. */
  fullWidth?: boolean;
  /** The id of the element. */
  id: string;
  /** `true` if the element is used for numeric values; otherwise, `false`. The default is `false`. */
  isNumeric?: boolean;
}

/** Represents a component for an input element. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { id, appearance, type = 'text', isNumeric, fullWidth, ...restProps }: InputProps,
  forwardedRef
) {
  return (
    <input
      {...restProps}
      ref={forwardedRef}
      id={id}
      className={clsx(styles['input'], {
        [styles['input--error']]: appearance === 'error',
        [styles['input--full-with']]: fullWidth,
        [styles['input--numeric']]: isNumeric,
      })}
      type={type}
    />
  );
});
